import { MenuItem } from "@/model/entities";
import _ from "lodash";

export const getMaxOrderInCategory = (
  menuItems: MenuItem[],
  categoryId: string,
): number => {
  const filteredMenuItems = _.filter(menuItems, { categoryId });
  return (
    _.maxBy(filteredMenuItems, (mi: MenuItem) => mi.order ?? 0)?.order ?? 0
  );
};
